
import React from 'react';

const AuthLoader: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="animate-pulse space-y-4">
        <div className="h-12 w-12 bg-primary/20 rounded-full mx-auto"></div>
        <div className="h-4 w-32 bg-primary/20 rounded mx-auto"></div>
        <p className="text-center text-sm text-muted-foreground mt-4">
          {message}
        </p>
      </div>
    </div>
  );
};

export default AuthLoader;
